class CustomHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.elms = {
            desktopMenu: this.querySelector(".js-header-menu"),
            desktopMenuOrigin: this.querySelector(".js-header-menu")?.cloneNode(true),
            drawerElms: {
                mobileDrawerTemplate: this.querySelector("#header-mobile-drawer-wrapper"),
                mobileDrawerHamburger: this.querySelector(".js-header-drawer-hamburger"),
                mobileDrawerMenu: null,
                mobileDrawerMenuOrigin: null,
            },
            searchElms: {
                searchTriggerIcon: this.querySelectorAll(".js-search-toggle-icon"),
            },
            desktopHamburger: this.querySelector(".js-header-sticky-hamburger"),
        };

        this.header = document.querySelector(".section-header-wrapper");
        this.initDesktopNavigation();
    }

    initDesktopNavigation() {
        let firstLevelMenuItems = this.querySelectorAll(".js-menu-item");
        let secondLevelMenuItems = this.querySelectorAll(".dropdown-menu--sublinks .menu-item");
        firstLevelMenuItems.forEach((item) => {
            if (Shopify.designMode) {
                const tempElement = item.querySelector(":scope > div:last-child");
                if (!!tempElement) {
                    const md5Code = tempElement.classList[0];
                    const megaMenuSection = document.querySelector(`.mega-menu-editor[data-code="${md5Code}"]`);
                    if (!!megaMenuSection) {
                        const megaMenuSectionClone = megaMenuSection.cloneNode(true);
                        megaMenuSectionClone.classList.remove("d-none");
                        item.appendChild(megaMenuSectionClone);
                        tempElement.remove();
                    }
                }
            }

            // update mega menu item classes
            if (item.querySelector("template") || item.querySelector(".mega-menu-editor")) {
                item.addClass("has-dropdown");
                item.addClass("mega-menu-item");
                item.querySelector(":first-child a").setAttribute("aria-expanded", "false");
            }

            // get mega content from template tag
            // ["mouseenter", "focusin"]
            ["mouseenter"].forEach((event) => {
                item.addEventListener(
                    event,
                    () => {
                        const megaMenuTemplate = item.querySelector(".temp-id") || item.querySelector(".mega-menu-editor");
                        if (!megaMenuTemplate) return;

                        if (item.querySelector(".dropdown-menu--sublinks")) {
                            item.querySelector(".dropdown-menu--sublinks").remove();
                        }

                        if (item.querySelector(".temp-id")) {
                            item.appendChild(megaMenuTemplate.content);
                            megaMenuTemplate.remove();
                        }

                        // Handles situations where mega content width is not enough to be hovered from the parent element
                        this.adjustMegaContentPosition(item);
                    },
                    { once: true }
                );
            });

            // hover
            item.addEventListener("mouseenter", function (e) {
                openDropdown(item);
            });

            item.addEventListener("mouseleave", function (e) {
                closeDropdown(item);
            });
        });

        secondLevelMenuItems.forEach((item) => {
            item.addEventListener("mouseenter", function (e) {
                openSubDropdown(item);
            });

            item.addEventListener("mouseleave", function (e) {
                closeSubDropdown(item);
            });
        });

        this.querySelector(".menu-content").addEventListener("mouseenter", (e) => {
            if (e.relatedTarget && e.relatedTarget.closest(".js-menu-item")) {
                e.relatedTarget.closest(".js-menu-item").classList.add("open");
                this.querySelector(`.menu-content > [data-menu-item-handle].open`)?.removeClass("open");
                this.querySelector(`.menu-banner > [data-menu-item-handle].open`)?.removeClass("open");

                this.querySelector(
                    `.menu-content > [data-menu-item-handle='${e.relatedTarget.closest(".js-menu-item").getAttribute("data-menu-item-handle")}']`
                )?.addClass("open");

                this.querySelector(
                    `.menu-banner > [data-menu-item-handle='${e.relatedTarget.closest(".js-menu-item").getAttribute("data-menu-item-handle")}']`
                )?.addClass("open");
            }
        });

        this.querySelector(".menu-content-child").addEventListener("mouseenter", (e) => {
            if (e.relatedTarget && e.relatedTarget.closest(".dropdown-menu--sublinks")) {
                e.relatedTarget.closest(".menu-content").querySelector(".dropdown-menu--sublinks.open")?.classList.remove("open");
                e.relatedTarget.closest(".dropdown-menu--sublinks").classList.add("open");

                this.querySelector(`.menu-content-child > [data-sub-menu-item-handle].open`)?.removeClass("open");
                this.querySelector(`.menu-banner > [data-menu-item-handle].open`)?.removeClass("open");

                this.querySelector(
                    `.menu-content-child > [data-sub-menu-item-handle='${e.relatedTarget
                        .closest(".menu-item")
                        .getAttribute("data-sub-menu-item-handle")}'][data-menu-item-handle='${e.relatedTarget
                        .closest(".dropdown-menu--sublinks")
                        .getAttribute("data-menu-item-handle")}']`
                )?.addClass("open");

                this.querySelector(
                    `.menu-banner > [data-menu-item-handle='${e.relatedTarget.closest(".dropdown-menu--sublinks").getAttribute("data-menu-item-handle")}']`
                )?.addClass("open");
            }
        });

        this.addEventListener("mouseenter", (e) => {
            if (!this.classList.contains("open")) {
                this.querySelector(".js-menu-item.open")?.removeClass("open");
                this.querySelector(".menu-content > .dropdown-menu--sublinks.open")?.removeClass("open");
                this.querySelector(".menu-content-child > .dropdown-menu--child-sublinks.open")?.removeClass("open");
                this.querySelector(".menu-banner > .banner.open")?.removeClass("open");

                const firstItem = this.querySelector(".js-menu-item");
                firstItem.addClass("open");
                this.querySelector(
                    `.menu-content > .dropdown-menu--sublinks[data-menu-item-handle='${firstItem.getAttribute("data-menu-item-handle")}']`
                )?.addClass("open");
                this.querySelector(
                    `.menu-content-child > .dropdown-menu--child-sublinks[data-menu-item-handle='${firstItem.getAttribute("data-menu-item-handle")}']`
                )?.addClass("open");
                this.querySelector(`.menu-banner > .banner[data-menu-item-handle='${firstItem.getAttribute("data-menu-item-handle")}']`)?.addClass("open");
            }
            this.addClass("open");
        });

        this.addEventListener("mouseleave", (e) => {
            this.removeClass("open");
        });

        this.querySelector(".arn-menu__background").addEventListener("mouseenter", (e) => {
            this.removeClass("open");
        });

        this.querySelector(".arn-menu__hamburger").addEventListener("click", (e) => {
            if (this.classList.contains("open")) {
                this.removeClass("open");
                this.querySelector(".js-menu-item.open")?.removeClass("open");
                this.querySelector(".menu-content > .dropdown-menu--sublinks.open")?.removeClass("open");
            }
        });

        function openDropdown(container) {
            container.closest(".js-header-menu").querySelector(".js-menu-item.open")?.removeClass("open");
            container.addClass("open");
            if (container.classList.contains("has-dropdown")) {
                container.querySelector(":first-child a").setAttribute("aria-expanded", "true");

                container.closest(".js-header-menu").querySelector(`.menu-content > [data-menu-item-handle].open`)?.removeClass("open");
                container.closest(".js-header-menu").querySelector(`.menu-banner > [data-menu-item-handle].open`)?.removeClass("open");

                const lv2 = container
                    .closest(".js-header-menu")
                    .querySelector(`.menu-content [data-menu-item-handle="${container.getAttribute("data-menu-item-handle")}"]`);
                lv2?.addClass("open");

                const lv2_banner = container
                    .closest(".js-header-menu")
                    .querySelector(`.menu-banner [data-menu-item-handle="${container.getAttribute("data-menu-item-handle")}"]`);
                lv2_banner?.addClass("open");
            }
        }

        function openSubDropdown(container) {
            container.closest(".js-header-menu").querySelector(".dropdown-menu--sublinks.open")?.classList.remove("open");
            container.closest(".js-header-menu").querySelector(".dropdown-menu--child-sublinks.open")?.classList.remove("open");
            container.closest(".dropdown-menu--sublinks").addClass("open");

            const lv3 = container
                .closest(".js-header-menu")
                .querySelector(
                    `.menu-content-child > [data-sub-menu-item-handle='${container.getAttribute(
                        "data-sub-menu-item-handle"
                    )}'][data-menu-item-handle='${container.closest(".dropdown-menu--sublinks").getAttribute("data-menu-item-handle")}']`
                );
            lv3?.addClass("open");
        }

        function closeSubDropdown(container) {
            container.closest(".dropdown-menu--sublinks").removeClass("open");
            const lv3 = container
                .closest(".js-header-menu")
                .querySelector(
                    `.menu-content-child [data-sub-menu-item-handle="${container.getAttribute("data-sub-menu-item-handle")}"][data-menu-item-handle='${container
                        .closest(".dropdown-menu--sublinks")
                        .getAttribute("data-menu-item-handle")}']`
                );
            lv3?.removeClass("open");
        }

        function closeDropdown(container) {
            container.removeClass("open");
            if (container.classList.contains("has-dropdown")) {
                container.querySelector(":first-child a").setAttribute("aria-expanded", "false");
                const lv2 = container
                    .closest(".js-header-menu")
                    .querySelector(`.menu-content [data-menu-item-handle='${container.getAttribute("data-menu-item-handle")}']`);
                lv2?.removeClass("open");

                const lv2_banner = container
                    .closest(".js-header-menu")
                    .querySelector(`.menu-banner [data-menu-item-handle='${container.getAttribute("data-menu-item-handle")}']`);
                lv2_banner?.removeClass("open");

                const lv3 = container
                    .closest(".js-header-menu")
                    .querySelector(`.menu-content-child [data-menu-item-handle='${container.getAttribute("data-menu-item-handle")}']`);
                lv3?.removeClass("open");
            }
        }

        this.adjustMegaContentPosition = (container, megaContentContainer = container) => {
            const megaContent = megaContentContainer.querySelector("mega-menu .dropdown-menu--mega");
            if (!megaContent) return;
            const containerWidth =
                document.body.clientWidth > window.theme.settings.pageWidth ? window.theme.settings.pageWidth - 20 : document.body.clientWidth - 20;
            const megaContentWidth = (parseInt(getComputedStyle(megaContent).width) * containerWidth) / 100;
            const megaContentRectLeft = (document.body.clientWidth - containerWidth) / 2;
            const megaContentRectRight = megaContentRectLeft + megaContentWidth;
            const menuItemRect = container.getBoundingClientRect();

            if (megaContentRectRight < menuItemRect.left) {
                megaContent.style.left = menuItemRect.right - megaContentRectRight + "px";
            }
        };
    }

    getFocusableElements(container) {
        return Array.from(
            container.querySelectorAll(
                "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
            )
        );
    }
}

customElements.define("c-header", CustomHeader);
